﻿/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-console */
/* eslint-disable max-len */
import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';

export default class KDMZWeb2print extends TKCustomElementFactory {
    submitBtn?: HTMLButtonElement;
    url?: string;

    constructor() {
        super();
        this.submitBtn = this.querySelector('[data-web2print-submit]') || undefined;
        this.url = this.dataset.url || undefined;
    }

    connectedCallback(): void {
        // if (!this.submitBtn || !this.url) throw new Error('KDMZWeb2print: something is missing!');
        // this.registerEventListener();
    }

    registerEventListener() {
        // this.pushListener({
        //     event: 'click',
        //     element: this.submitBtn!,
        //     action: this.sendForm.bind(this),
        // });
    }

    sendForm(event : Event) : void {
        const payload = {};

        fetchRequest({
            requestURL: this.url!,
            payload,
            resolveHandler: this.setDataAndCloseDialog.bind(this),
        });
    }

    setDataAndCloseDialog(response: TKResponse) {
        // console.log(response.dataAsJson);
        if (response.status === 'ok') {
            location.reload();
        }
    }
}
